module.exports = __webpack_public_path__ + "img/cons_5.1f048de0.jpg";